<template>
    <v-main>
        <TheHeader />
        <router-view />
        <TheFooter />
    </v-main>
</template>

<script>
import TheHeader from '@/components/TheHeader';
import TheFooter from '@/components/TheFooter';

export default {
  name: 'DefaultLayout',

  components: {
    TheHeader,
    TheFooter,
  },
};
</script>

<style lang="scss">
.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

.v-main .v-main__wrap {
  display: flex;
  flex-direction: column;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
}

.rotate {
  animation: rotate .5s;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

.basket-btn {
  font-size: .75rem;

  .v-btn__content {
    flex-direction: column-reverse !important;
    font-size: .75rem;
    line-height: 1.2;
    text-transform: none;
  }
}
</style>
